/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// const awsmobile = {
//     "aws_project_region": "us-east-1",
//     "aws_cognito_identity_pool_id": "us-east-1:75e9196a-fd71-476d-a7e6-50c4322f529b",
//     "aws_cognito_region": "us-east-1",
//     "aws_user_pools_id": "us-east-1_EVZDZQ1ZB",
//     "aws_user_pools_web_client_id": "19jcl0ppet56rkh10vk6ss9h6",
//     "oauth": {
//         "domain": "auth.quizwizard.net",      
//         "scope": [
//             "phone",
//             "email",
//             "openid",
//             "profile",
//             "aws.cognito.signin.user.admin"
//         ],
//         "redirectSignIn": "https://quizwizard.net/practiceevents",
//         "redirectSignOut": "https://quizwizard.net",
//         "responseType": "code"
//     },
//     "federationTarget": "COGNITO_USER_POOLS"
// };

// dev only//

// const awsmobile = {
//     "aws_project_region": "us-east-1",
//     "aws_cognito_region": "us-east-1",
//     "aws_user_pools_id": "us-east-1_rqOoi1KTo",
//     "aws_user_pools_web_client_id": "cef6gei2pa75fgekub7echlfq",
//     "oauth": {},
//     "federationTarget": "COGNITO_USER_POOLS"
// };
// =================================//

// prod only//
const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_042OYmN4v",
    "aws_user_pools_web_client_id": "3k84pn4thpkl6v8vp6rin53qa9",
    "oauth": {
        "domain": "auth.quizwizard.net",      
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://prod.quizwizard.net/practiceevents",
        "redirectSignOut": "https://prod.quizwizard.net",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};

export default awsmobile;
